
import { MOCK_SITE_SAMPLE_IDS } from "./constants";


export const getSiteDetails = (site) => {

  switch (site) {
    case MOCK_SITE_SAMPLE_IDS.optimisation_amber:
      return amberDetails;
    // case MOCK_SITE_SAMPLE_IDS.optimisation_tou:
    //   return tou_details;
    // case MOCK_SITE_SAMPLE_IDS.notification_backup:
    //   return amber_details;
    default:
      return getDefaultSiteDetails()
  }

};

const amberDetails = {
  id: "1232ac6b-17dd-4640-b0fd-8cab8e8cdabc",
  serial: "EB0010100001",
  reserved: 0,
  timestamp: 1742645652,
  solar: 0,
  grid: -3394,
  battery: 4975,
  hotwater: 0,
  ev: 0,
  ev_status: "charging",
  soc: 73.1194,
  backup: false,
  grid_present: true,
  online: true,
  ethernet: 0,
  modem: 2,
  wifi: 5,
  boost_id: null,
  storm_id: null,
  price_import: 13.1472242,
  price_export: -11.886568,
}

let counter = 1;
let index = 0;

const getDefaultSiteDetails = () => {

  const data = siteDetailsArray[index];

  index = index + 1;
  if (index >= siteDetailsArray.length) {
    index = 0;
  }
  counter = counter + 1;

  return data;
}

const siteDetailsArray = [
  {
    id: "1232ac6b-17dd-4640-b0fd-8cab8e8cdabc",
    serial: "EB0010100001",
    reserved: 0,
    timestamp: 1742645652,
    solar: 7800,
    grid: 1030,
    battery: -4895,
    hotwater: 1330,
    ev: 2400,
    ev_status: "charging",
    soc: 66,
    backup: false,
    grid_present: true,
    online: true,
    ethernet: 0,
    modem: 2,
    wifi: 5,
    boost_id: null,
    storm_id: null,
    price_import: 0.36016,
    price_export: -0.28135,
  },
  {
    id: "1232ac6b-17dd-4640-b0fd-8cab8e8cdabc",
    serial: "EB0010100001",
    reserved: 0,
    timestamp: 1742645712,
    solar: 7900,
    grid: 0,
    battery: -4595,
    hotwater: 0,
    ev: 2500,
    ev_status: "charging",
    soc: 66,
    backup: false,
    grid_present: true,
    online: true,
    ethernet: 0,
    modem: 2,
    wifi: 5,
    boost_id: null,
    storm_id: null,
    price_import: 0.36016,
    price_export: -0.28135,
  },
  {
    id: "1232ac6b-17dd-4640-b0fd-8cab8e8cdabc",
    serial: "EB0010100001",
    reserved: 0,
    timestamp: 1742645772,
    solar: 7900,
    grid: 0,
    battery: -4595,
    hotwater: 0,
    ev: 2300,
    ev_status: "charging",
    soc: 68,
    backup: false,
    grid_present: true,
    online: true,
    ethernet: 0,
    modem: 2,
    wifi: 5,
    boost_id: null,
    storm_id: null,
    price_import: 0.36016,
    price_export: -0.28135,
  },
  {
    id: "1232ac6b-17dd-4640-b0fd-8cab8e8cdabc",
    serial: "EB0010100001",
    reserved: 0,
    timestamp: 1742645832,
    solar: 7900,
    grid: 0,
    battery: -4295,
    hotwater: 0,
    ev: 2400,
    ev_status: "charging",
    soc: 69,
    backup: false,
    grid_present: true,
    online: true,
    ethernet: 0,
    modem: 2,
    wifi: 5,
    boost_id: null,
    storm_id: null,
    price_import: 0.36016,
    price_export: -0.28135,
  },
];
